import { CompositeView, LayoutView } from 'backbone.marionette';

import PageView from '../../../base/views/page';
import ContactList from '../../collections/contact';

import { FilterView } from '../../../forms/filter/view';
import { Filter } from '../../../forms/filter/model';

const OptionView = LayoutView.extend({
  tagName: 'option',
  template: require('../../templates/contact/option.html'),

  attributes() {
    return {
      value: this.model.id || ''
    };
  },

  templateHelpers() {
    const { first_name, last_name, school_class } = this.model.pick(
      'first_name',
      'last_name',
      'school_class'
    );
    const classDisplay = school_class ? ` (${school_class})` : '';
    const display_name =
      first_name && last_name
        ? `${last_name}, ${first_name}${classDisplay}`
        : '--- New Name ---';

    return { display_name };
  },

  onBeforeRender() {
    const selected = this.getOption('selected');
    this.$el.prop('selected', !!selected);
  }
});

const ContactView = CompositeView.extend({
  tagName: 'tr',
  template: require('../../templates/contact/row.html'),
  childViewContainer: 'select',
  childView: OptionView,

  childViewOptions(model) {
    const match = model.id === this.model.get('match');
    return {
      selected: match
    };
  },

  regions: {
    match: '.match'
  },

  modelEvents: {
    'change:contact': 'changeModel',
    'change:match': 'changeModel',
    'change': 'render'
  },

  ui: {
    cell: 'td:not(.match)',
    match: '.match select'
  },

  triggers: {
    'click @ui.cell': 'change:selected',
    'change @ui.match': 'select:match'
  },

  templateHelpers() {
    const model = this.model;

    return {
      getSelected() {
        return model.get('selected') || false;
      }
    };
  },

  initialize() {
    const options = new Backbone.Collection(
      this.model.get('potential_matches')
    );
    options.add({ value: '' }, { at: 0 });
    this.collection = options;

    this.model.set(
      {
        selected: this.options.selected,
        match: this.options.match
      },
      { silent: true }
    );
  },

  /**
   * Handle the user selecting a checkbox on the contact table.
   * @returns {undefined}
   */
  onChangeSelected() {
    const selected = !this.model.get('selected');
    const contact = selected ? this.model.id : null;
    this.model.set({ selected, contact });
  },

  /**
   * Trigger the updated contact.
   * @param {Backbone.Model} model The updated Contact
   * @returns {undefined}
   */
  changeModel(model) {
    const { selected, match } = model.pick('selected', 'match');
    const options = {
      checked: selected,
      match,
      id: this.model.id
    };
    this.trigger('change:contact', options);
  },

  onBeforeRender() {
    if (this.model.get('selected')) {
      this.$el.addClass('selected');
    } else {
      this.$el.removeClass('selected');
    }
  },

  onSelectMatch() {
    const match = this.ui.match.val();

    if (match) {
      this.model.set({
        match: parseInt(match, 10),
        selected: true
      });
    } else {
      this.model.set('match', undefined);
    }
  }
});

const TableView = CompositeView.extend({
  tagName: 'table',
  className: 'datatable',
  template: require('../../templates/contact/table.html'),
  childView: ContactView,
  childViewContainer: 'tbody',

  childViewOptions(model, index) {
    const selected = this.options.selected.get(model.id);
    const match = selected ? selected.get('match') : null;

    return {
      match,
      className: index % 2 ? '' : 'alt',
      selected: selected ? true : false
    };
  },

  onChildviewChangeContact(child, value) {
    const exists = this.options.selected.get(value.id);
    if (exists) {
      this.options.selected.remove(value.id);
    }
    if (value.checked) {
      this.options.selected.add({
        id: value.id,
        contact: value.id,
        match: value.match
      });
    }
  }
});

export const ContactLayoutView = LayoutView.extend({
  template: require('../../templates/contact/index.html'),

  regions: {
    contacts: '#datatable-hook',
    filter: '.filter-hook',
    paging: '.page-hook'
  },

  collectionEvents: {
    request: 'onRequest'
  },

  ui: {
    save: '#btn-import',
    import_all: '.import-all'
  },

  events: {
    'click @ui.save': 'importContacts',
    'click @ui.import_all': 'importBulk'
  },

  initialize(options) {
    this.collection = new ContactList([], { urlBase: options.contact_url });
  },

  onRender() {
    const contacts = new ContactList([], { urlBase: this.collection.urlBase });
    contacts.fetch();

    const tableView = new TableView({
      collection: contacts,
      selected: this.collection
    });

    const page = new PageView({ collection: contacts });
    const filter = new FilterView({
      collection: contacts,
      model: new Filter()
    });

    this.showChildView('filter', filter);
    this.showChildView('contacts', tableView);
    this.showChildView('paging', page);
  },

  importContacts() {
    const contacts = this.contacts.currentView.collection;
    const names = this.collection.length;

    this.collection.sync('create', this.collection, {
      url: this.collection.url(),
      success() {
        contacts.fetch();
        window.messages.add(`${names} names imported.`);
      }
    });
  },

  importBulk() {
    const contacts = this.getChildView('contacts').collection;
    const importAll = this.getOption('import_all');
    const importCollection = new ContactList(null, { urlBase: importAll });
    const collection = this.collection;
    importCollection.sync('create', this.collection, {
      url: importAll,
      success(response) {
        contacts.fetch();
        collection.reset([]);
        window.messages.add(response + ' names imported.');
      }
    });
  },

  onRequest() {
    window.messages.add('Importing names.');
    this.collection.reset([]);
  }
});



// WEBPACK FOOTER //
// ./parentpay/views/contact/index.js